import React from "react"
import { useTranslation } from "react-i18next"

import { LanguageSelector } from "components/Elements/LanguageSelector"

import "./Footer.scoped.scss"

export const Footer = ({ className }) => {
    const { t } = useTranslation()


    return (
        <footer className={`c-footer py-4 ${className ? className : ""}`}>
            <div className="flex flex-col md:flex-row items-center lg:justify-center px-5">
                <LanguageSelector className="ml-5"/>

                <nav className={"flex flex-col md:flex-row items-center lg:justify-center w-full"}>
                    <span className="italic py-1">{new Date().getFullYear()} {t("menu.copyright")}</span>

                    <div className="px-5">
                        Version: {process.env.REACT_APP_VERSION} {process.env.REACT_APP_MODE === "development" && " - TEST"}
                    </div>
                </nav>
            </div>
        </footer>
    )
}

